import React, { useState } from 'react';
import { 
  FaCcVisa, 
  FaCcMastercard, 
  FaApple, 
  FaGooglePay, 
  FaTripadvisor, 
  FaAward,
  FaRegCreditCard,
  FaPaypal,
  FaShieldAlt,
  FaHeadset,
  FaClock,
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaLinkedin,
  FaYoutube,
  FaAndroid,
  FaApple as FaAppleIcon,
  FaChevronRight,
  FaChevronDown,
  FaStar,
  FaRupeeSign,
  FaTaxi,
  FaPlane,
  FaTrain,
  FaBus,
  FaHotel,
  FaWhatsapp,
  FaArrowRight
} from 'react-icons/fa';
import { 
  SiVisa, 
  SiMastercard, 
  SiAmericanexpress,
  SiRazorpay,
  SiPhonepe,
  SiPaytm,
  SiDiscover,
  SiDinersclub
} from 'react-icons/si';
import logo from "../Assests/bookinindia-logo-optimized.png"

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [openSections, setOpenSections] = useState({});

  const toggleSection = (title) => {
    setOpenSections(prev => ({
      ...prev,
      [title]: !prev[title]
    }));
  };

  // Desktop Navigation Structure
  const desktopNavSections = [
    {
      title: "Cab Services",
      links: [
        { name: "Airport Taxi", href: "/airport" },
        { name: "Outstation Cabs", href: "/outstation" },
        { name: "Hourly Rentals", href: "/hourly" },
        { name: "Corporate Travel", href: "/corporate" },
        { name: "Wedding Fleet", href: "/wedding" },
        { name: "Event Transfers", href: "/events" }
      ]
    },
    {
      title: "Popular Routes",
      links: [
        { name: "Delhi → Jaipur", price: "₹2,999", href: "/delhi-jaipur" },
        { name: "Mumbai → Pune", price: "₹2,499", href: "/mumbai-pune" },
        { name: "Bangalore → Mysore", price: "₹3,299", href: "/bangalore-mysore" },
        { name: "Chennai → Pondy", price: "₹4,299", href: "/chennai-pondy" },
        { name: "Kolkata → Digha", price: "₹3,999", href: "/kolkata-digha" },
        { name: "Hyderabad → Vizag", price: "₹5,299", href: "/hyderabad-vizag" }
      ]
    },
    {
      title: "Company",
      links: [
        { name: "About Us", href: "/about" },
        { name: "Careers", href: "/careers", badge: "We're Hiring" },
        { name: "Blog", href: "/blog" },
        { name: "Press Releases", href: "/press" },
        { name: "Investor Relations", href: "/investors" },
        { name: "Sustainability", href: "/sustainability" }
      ]
    },
    {
      title: "Support",
      links: [
        { name: "Help Center", href: "/help" },
        { name: "Safety Guidelines", href: "/safety" },
        { name: "Cancellation Policy", href: "/cancellation" },
        { name: "Feedback", href: "/feedback" },
        { name: "Report Issue", href: "/report" },
        { name: "Contact Us", href: "/contact" }
      ]
    }
  ];

  // Mobile Navigation Data
  const mobileNavSections = [
    {
      title: "Book Cab",
      icon: <FaTaxi />,
      links: [
        { name: "Airport Taxi", icon: <FaPlane /> },
        { name: "Outstation", icon: <FaMapMarkerAlt /> },
        { name: "Hourly Rental", icon: <FaClock /> },
        { name: "Corporate", icon: <FaAward /> }
      ]
    },
    {
      title: "Popular Routes",
      icon: <FaStar />,
      links: [
        { name: "Delhi-Jaipur", price: "₹2,999" },
        { name: "Mumbai-Pune", price: "₹2,499" },
        { name: "Bangalore-Mysore", price: "₹3,299" },
        { name: "Chennai-Pondy", price: "₹4,299" }
      ]
    },
    {
      title: "Company",
      icon: <FaAward />,
      links: [
        { name: "About Us" },
        { name: "Careers", badge: "Hiring" },
        { name: "Blog" },
        { name: "Contact" }
      ]
    },
    {
      title: "Support",
      icon: <FaHeadset />,
      links: [
        { name: "Help Center" },
        { name: "Safety" },
        { name: "Terms" },
        { name: "Privacy" }
      ]
    }
  ];

  const paymentMethods = {
    cards: [
      { icon: <SiVisa className="w-8 h-8" />, name: "Visa" },
      { icon: <SiMastercard className="w-8 h-8" />, name: "Mastercard" },
      { icon: <SiAmericanexpress className="w-8 h-8" />, name: "Amex" },
      { icon: <SiDiscover className="w-8 h-8" />, name: "Discover" },
      // { icon: <SiDinersclub className="w-8 h-8" />, name: "Diners" }
    ],
    upi: [
      { icon: <FaGooglePay className="w-8 h-8" />, name: "Google Pay" },
      { icon: <SiPhonepe className="w-8 h-8" />, name: "PhonePe" },
      { icon: <SiPaytm className="w-8 h-8" />, name: "Paytm" },
      { icon: <FaApple className="w-8 h-8" />, name: "Apple Pay" }
    ]
  };

  const appLinks = [
    { icon: <FaAndroid />, name: "Google Play", rating: "4.5★", downloads: "10M+" },
    { icon: <FaAppleIcon />, name: "App Store", rating: "4.7★", downloads: "5M+" }
  ];

  const socialLinks = [
    { icon: <FaFacebook />, name: "Facebook", url: "#", color: "#1877F2", followers: "2M" },
    { icon: <FaTwitter />, name: "Twitter", url: "#", color: "#1DA1F2", followers: "1.5M" },
    { icon: <FaInstagram />, name: "Instagram", url: "#", color: "#E4405F", followers: "3M" },
    { icon: <FaLinkedin />, name: "LinkedIn", url: "#", color: "#0A66C2", followers: "500K" },
    { icon: <FaYoutube />, name: "YouTube", url: "#", color: "#FF0000", followers: "1M" },
    { icon: <FaWhatsapp />, name: "WhatsApp", url: "#", color: "#25D366", followers: "100K" }
  ];

  const contactInfo = [
    { icon: <FaPhone />, text: "+91 98765 43210", sub: "24/7 Customer Support" },
    { icon: <FaEnvelope />, text: "support@bookinindia.com", sub: "Response within 2 hrs" },
    { icon: <FaMapMarkerAlt />, text: "Mumbai, India - 400001", sub: "Corporate Office" }
  ];

  const features = [
    { icon: "🛡️", title: "Safe Rides", desc: "Sanitized cabs & trained drivers" },
    { icon: "⭐", title: "4.5+ Rating", desc: "From 50,000+ happy customers" },
    { icon: "💰", title: "Best Price", desc: "Price match guarantee" },
    { icon: "🔄", title: "Free Cancellation", desc: "Up to 2 hours before trip" }
  ];

  const awards = [
    { name: "Best Travel App 2023", org: "Google Play" },
    { name: "Customer Excellence Award", org: "Times Group" },
    { name: "Safe Travel Partner", org: "Ministry of Tourism" }
  ];

  return (
    <footer className="bg-white">
      {/* Desktop View - Hidden on Mobile */}
      <div className="hidden lg:block">
        {/* Desktop Newsletter Bar */}
        {/* <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white py-8">
          <div className="max-w-7xl mx-auto px-8 flex items-center justify-between">
            <div className="flex items-center gap-4">
              <div className="bg-white/20 p-3 rounded-full">
                <FaHeadset className="w-6 h-6" />
              </div>
              <div>
                <h3 className="font-bold text-lg">Get 20% off on your first ride</h3>
                <p className="text-blue-100 text-sm">Subscribe for exclusive deals and updates</p>
              </div>
            </div>
            <div className="flex gap-3">
              <input
                type="email"
                placeholder="Enter your email"
                className="px-4 py-2 rounded-lg text-gray-900 w-64 focus:outline-none"
              />
              <button className="bg-white text-blue-600 px-6 py-2 rounded-lg font-medium hover:bg-blue-50 transition-colors">
                Subscribe
              </button>
            </div>
          </div>
        </div> */}

        {/* Desktop Main Footer */}
        <div className="max-w-7xl mx-auto px-8 py-12">
          {/* Top Section with Logo and Description */}
          <div className="flex justify-between items-start mb-10 pb-10 border-b border-gray-200">
            <div className="max-w-md">
              <h2 className="text-2xl font-bold text-gray-900 mb-3">BookInIndia<span className="text-red-600">.com</span></h2>
              <p className="text-gray-500 text-sm leading-relaxed">
                India's most trusted cab booking platform. Choose from 10,000+ cabs across 100+ cities. 
                Safe, reliable, and affordable travel solutions for every journey.
              </p>
              <div className="flex gap-4 mt-4">
                {awards.map((award, idx) => (
                  <div key={idx} className="flex items-center gap-2 text-xs bg-gray-50 px-3 py-2 rounded-full">
                    <FaAward className="text-yellow-500" />
                    <span className="font-medium text-gray-700">{award.name}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="flex gap-6">
              {appLinks.map((app) => (
                <a
                  key={app.name}
                  href="#"
                  className="flex items-center gap-3 bg-gray-900 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition-all"
                >
                  {app.icon}
                  <div>
                    <div className="text-xs opacity-80">{app.name}</div>
                    <div className="font-bold text-sm">{app.rating} • {app.downloads}</div>
                  </div>
                </a>
              ))}
            </div>
          </div>

          {/* Navigation Grid */}
          <div className="grid grid-cols-4 gap-8 mb-10">
            {desktopNavSections.map((section) => (
              <div key={section.title}>
                <h3 className="font-bold text-gray-900 mb-4 flex items-center gap-2">
                  {section.title}
                  <div className="h-0.5 w-8 bg-blue-600 rounded-full"></div>
                </h3>
                <ul className="space-y-3">
                  {section.links.map((link) => (
                    <li key={link.name}>
                      <a 
                        href={link.href}
                        className="text-gray-600 hover:text-blue-600 text-sm flex items-center justify-between group"
                      >
                        <span className="flex items-center gap-1">
                          {link.name}
                          {link.badge && (
                            <span className="ml-2 text-[10px] bg-green-100 text-green-600 px-1.5 py-0.5 rounded-full">
                              {link.badge}
                            </span>
                          )}
                        </span>
                        {link.price && (
                          <span className="text-xs font-bold text-green-600">{link.price}</span>
                        )}
                        <FaChevronRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-all" />
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Features Grid */}
          {/* <div className="grid grid-cols-4 gap-6 mb-10 p-6 bg-gray-50 rounded-xl">
            {features.map((feature, idx) => (
              <div key={idx} className="flex items-center gap-3">
                <span className="text-2xl">{feature.icon}</span>
                <div>
                  <h4 className="font-bold text-sm text-gray-900">{feature.title}</h4>
                  <p className="text-xs text-gray-500">{feature.desc}</p>
                </div>
              </div>
            ))}
          </div> */}

          {/* Payment Methods and Social */}
          <div className="grid grid-cols-2 gap-8 mb-10">
            <div>
              <h3 className="font-bold text-gray-900 mb-4">Payment Methods</h3>
              <div className="space-y-4">
                <div className="flex flex-wrap gap-3">
                  {paymentMethods.cards.map((method) => (
                    <div key={method.name} className="bg-white border border-gray-200 rounded-lg px-3 py-2 flex items-center gap-2 hover:shadow-md transition-shadow">
                      {method.icon}
                      <span className="text-sm font-medium text-gray-600">{method.name}</span>
                    </div>
                  ))}
                </div>
                <div className="flex flex-wrap gap-3">
                  {paymentMethods.upi.map((method) => (
                    <div key={method.name} className="bg-white border border-gray-200 rounded-lg px-3 py-2 flex items-center gap-2 hover:shadow-md transition-shadow">
                      {method.icon}
                      <span className="text-sm font-medium text-gray-600">{method.name}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div>
              <h3 className="font-bold text-gray-900 mb-4">Connect With Us</h3>
              <div className="flex flex-wrap gap-3">
                {socialLinks.map((social) => (
                  <a
                    key={social.name}
                    href={social.url}
                    className="group relative"
                  >
                    <div 
                      className="w-10 h-10 rounded-full flex items-center justify-center text-xl transition-all hover:scale-110"
                      style={{ backgroundColor: social.color + '20', color: social.color }}
                    >
                      {social.icon}
                    </div>
                    <span className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-gray-900 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
                      {social.followers} followers
                    </span>
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Contact Info */}
          {/* <div className="grid grid-cols-3 gap-6 p-6 bg-gray-50 rounded-xl mb-8">
            {contactInfo.map((item, idx) => (
              <div key={idx} className="flex items-center gap-3">
                <div className="bg-blue-100 p-3 rounded-full text-blue-600">
                  {item.icon}
                </div>
                <div>
                  <div className="font-bold text-gray-900">{item.text}</div>
                  <div className="text-xs text-gray-500">{item.sub}</div>
                </div>
              </div>
            ))}
          </div> */}

          {/* Bottom Bar */}
          <div className="flex justify-between items-center pt-6 border-t border-gray-200 text-xs text-gray-500">
            <div className="flex gap-6">
              <span>© {currentYear} BookInIndia.com. All rights reserved.</span>
              <a href="#" className="hover:text-blue-600">Terms of Use</a>
              <a href="#" className="hover:text-blue-600">Privacy Policy</a>
              <a href="#" className="hover:text-blue-600">Cookie Policy</a>
              <a href="#" className="hover:text-blue-600">Sitemap</a>
            </div>
            <div className="flex gap-3 h-auto">
              <img src="https://img.freepik.com/premium-vector/secure-ssl-encryption-logo-secure-connection-icon-vector-illustration-ssl-certificate-icon_526569-865.jpg" alt="SSL Secure" className="h-5" />
              <img src="https://www.catonetworks.com/wp-content/uploads/2025/02/Is-your-SASE-Platform-PCI-4.0-certified_-It-should-be.-1200x794-1.png" alt="PCI Compliant" className="h-5" />
            </div>
          </div>
        </div>
      </div>

      {/* Mobile View - Hidden on Desktop */}
      <div className="lg:hidden bg-white">
        {/* Mobile App Banner */}
        <div className="bg-[#e71204] text-white p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="font-bold text-sm">Get the App</p>
              <p className="text-xs opacity-90">Save up to 20% on every ride</p>
            </div>
            <div className="flex gap-2">
              <button className="bg-gray-900 backdrop-blur px-3 py-1.5 rounded-lg text-xs font-medium flex items-center gap-1">
                <FaAndroid /> Google
              </button>
              <button className="bg-gray-900 backdrop-blur px-3 py-1.5 rounded-lg text-xs font-medium flex items-center gap-1">
                <FaAppleIcon /> Apple
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Main Content */}
        <div className="px-4 py-4">
          {/* Mobile Rating Card */}
        

          {/* Mobile Expandable Sections */}
          <div className="space-y-2 mb-4">
            {mobileNavSections.map((section) => (
              <div key={section.title} className="border border-gray-100 rounded-lg overflow-hidden">
                <button
                  onClick={() => toggleSection(section.title)}
                  className="w-full flex items-center justify-between p-3 bg-gray-50"
                >
                  <div className="flex items-center gap-2">
                    <span className="text-gray-900">{section.icon}</span>
                    <span className="font-medium text-sm">{section.title}</span>
                  </div>
                  <FaChevronDown className={`text-gray-400 transition-transform ${openSections[section.title] ? 'rotate-180' : ''}`} />
                </button>
                {openSections[section.title] && (
                  <div className="p-3 bg-white grid grid-cols-2 gap-2">
                    {section.links.map((link, idx) => (
                      <a key={idx} href="#" className="p-2 bg-gray-50 rounded-lg text-center">
                        <span className="text-xs font-medium">{link.name}</span>
                        {link.price && <span className="text-[10px] text-green-600 block font-bold">{link.price}</span>}
                        {link.icon && <span className="text-blue-600 text-xs block">{link.icon}</span>}
                        {link.badge && <span className="text-[8px] bg-red-500 text-white px-1 rounded-full ml-1">{link.badge}</span>}
                      </a>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Mobile Quick Actions */}
          <div className="grid grid-cols-4 gap-2 mb-4">
            <button className="bg-red-50 p-2 rounded-lg text-center">
              <FaPhone className="text-blue-600 mx-auto mb-1" />
              <span className="text-[10px] font-medium">Call Us</span>
            </button>
            <button className="bg-red-50 p-2 rounded-lg text-center">
              <FaWhatsapp className="text-green-600 mx-auto mb-1" />
              <span className="text-[10px] font-medium">WhatsApp</span>
            </button>
            <button className="bg-red-50 p-2 rounded-lg text-center">
              <FaEnvelope className="text-blue-600 mx-auto mb-1" />
              <span className="text-[10px] font-medium">Email</span>
            </button>
            <button className="bg-red-50 p-2 rounded-lg text-center">
              <FaHeadset className="text-blue-600 mx-auto mb-1" />
              <span className="text-[10px] font-medium">Chat</span>
            </button>
          </div>

          {/* Mobile Payment Methods */}
          <div className="mb-4">
            <p className="text-xs font-medium text-gray-500 mb-2">We Accept</p>
            <div className="flex flex-wrap gap-2">
              {[...paymentMethods.cards, ...paymentMethods.upi].map((method, idx) => (
                <div key={idx} className="bg-white border border-gray-200 rounded-lg px-2 py-1 flex items-center gap-1">
                  {method.icon}
                  <span className="text-[8px] font-medium text-gray-600">{method.name}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Mobile Trust Badges */}
          <div className="grid grid-cols-3 gap-2 mb-4">
            <div className="text-center p-2 bg-gray-50 rounded-lg">
              <FaShieldAlt className="text-green-600 mx-auto mb-1" />
              <span className="text-[8px] font-medium">Safe Travel</span>
            </div>
            <div className="text-center p-2 bg-gray-50 rounded-lg">
              <FaClock className="text-blue-600 mx-auto mb-1" />
              <span className="text-[8px] font-medium">On Time</span>
            </div>
            <div className="text-center p-2 bg-gray-50 rounded-lg">
              <FaAward className="text-yellow-600 mx-auto mb-1" />
              <span className="text-[8px] font-medium">Best Price</span>
            </div>
          </div>

          {/* Mobile Newsletter */}
          <div className="bg-gradient-to-r from-red-50 to-red-50 p-4 rounded-xl mb-4">
            <p className="font-bold text-sm mb-1">Get ₹200 off</p>
            <p className="text-xs text-gray-600 mb-2">on your next ride</p>
            <div className="flex gap-2">
              <input
                type="email"
                placeholder="Enter mobile number"
                className="flex-1 px-3 py-2 text-xs border border-gray-200 rounded-lg focus:outline-none focus:border-blue-500"
              />
              <button className="bg-[#E31837] text-white px-4 py-2 text-xs font-medium rounded-lg whitespace-nowrap">
                Get Code
              </button>
            </div>
          </div>

          {/* Mobile Footer Bottom */}
          <div className="text-center pt-4 border-t border-gray-100">
            <p className="text-[10px] text-gray-400 mb-2">
              © {currentYear} BookInIndia.com. All rights reserved.
            </p>
            <div className="flex justify-center gap-3 mb-3">
              <a href="#" className="text-gray-400 hover:text-blue-600">
                <FaFacebook className="w-4 h-4" />
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-600">
                <FaInstagram className="w-4 h-4" />
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-600">
                <FaTwitter className="w-4 h-4" />
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-600">
                <FaYoutube className="w-4 h-4" />
              </a>
            </div>
            <div className="flex justify-center gap-4 text-[8px] text-gray-300">
              <a href="#">Terms</a>
              <a href="#">Privacy</a>
              <a href="#">Cookies</a>
              <a href="#">Contact</a>
            </div>
          </div>
        </div>

        {/* Mobile Bottom Navigation */}
        {/* <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-4 py-2 flex justify-around items-center">
          <button className="flex flex-col items-center">
            <FaTaxi className="text-blue-600 w-5 h-5" />
            <span className="text-[8px] mt-1">Book</span>
          </button>
          <button className="flex flex-col items-center">
            <FaStar className="text-gray-400 w-5 h-5" />
            <span className="text-[8px] mt-1">Offers</span>
          </button>
          <button className="flex flex-col items-center relative">
            <div className="absolute -top-5 bg-blue-600 text-white p-3 rounded-full">
              <FaHeadset className="w-5 h-5" />
            </div>
            <span className="text-[8px] mt-6">Support</span>
          </button>
          <button className="flex flex-col items-center">
            <FaClock className="text-gray-400 w-5 h-5" />
            <span className="text-[8px] mt-1">Trips</span>
          </button>
          <button className="flex flex-col items-center">
            <FaClock className="text-gray-400 w-5 h-5" />
            <span className="text-[8px] mt-1">Profile</span>
          </button>
        </div> */}
      </div>

      {/* Add padding at bottom for mobile to account for bottom nav */}
      <div className="lg:hidden h-16"></div>
    </footer>
  );
};

export default Footer;
